import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotGossipGrid() {
  const hotArticles = articles.filter(a => a.isHot).slice(0, 5);
  const featuredArticle = hotArticles[0];
  const gridArticles = hotArticles.slice(1);

  const catMap = Object.fromEntries(categories.map(c => [c.slug, c.name]));

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 md:mb-10 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-1.5 h-5 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-foreground-400 font-label tracking-widest uppercase">
                HOT GOSSIP
              </span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              热门吃瓜
            </h2>
          </div>
          <Link
            to="/category/meiri-dagua"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {featuredArticle && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6 mb-6">
            <div className="lg:col-span-2">
              <ArticleCard
                slug={featuredArticle.slug}
                title={featuredArticle.title}
                excerpt={featuredArticle.excerpt}
                imageUrl={featuredArticle.imageUrl}
                category={featuredArticle.category}
                categoryName={catMap[featuredArticle.category] || featuredArticle.category}
                publishedAt={featuredArticle.publishedAt}
                views={featuredArticle.views}
                comments={featuredArticle.comments}
                isHot={featuredArticle.isHot}
                variant="featured"
              />
            </div>
            <div className="flex flex-col gap-3 bg-background-100 rounded-xl border border-background-200/30 p-3 md:p-4">
              <h4 className="text-sm font-semibold text-foreground-700 font-label tracking-wide uppercase px-1">
                24小时热榜
              </h4>
              {gridArticles.map((article, idx) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  imageUrl={article.imageUrl}
                  category={article.category}
                  categoryName={catMap[article.category] || article.category}
                  publishedAt={article.publishedAt}
                  views={article.views}
                  comments={article.comments}
                  variant="compact"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}